import { SyntheticEvent } from 'react'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import Instructions from './field-instructions'
import Title from './field-title'

type Props = {
    className?: string
    field: CreationToolUploadField
    description: string
    isBulk?: boolean
    showDescriptionAsPlaceholder?: boolean
    showInstructions?: boolean
    onChange: (description: string) => void
}

const CreationDescriptionField = ({
    className,
    field,
    description,
    showDescriptionAsPlaceholder = false,
    showInstructions = false,
    isBulk = false,
    onChange,
}: Props) => {
    const placeholder = CreationToolUploadField.description(field)
    const maxLength = CreationToolUploadField.maxCharacterCount(field)

    const onInput = (e: SyntheticEvent<HTMLTextAreaElement, InputEvent>) => {
        onChange(e.currentTarget.value || '')
    }

    return (
        <UploadFieldBlock className={className}>
            <Title field={field}>{isBulk ? ` (Bulk)` : ''}</Title>
            <textarea
                {...{
                    defaultValue: description,
                    placeholder: showDescriptionAsPlaceholder ? description || placeholder : placeholder,
                    maxLength: maxLength || undefined,
                    onInput,
                }}
            />
            {showInstructions && <Instructions field={field} />}
        </UploadFieldBlock>
    )
}

export default CreationDescriptionField
